<template>
    <div
        class="c-row"
        :class="{ 'summary-row--invalid': row.status === $options.VALID_DATA_STATUS.INVALID }"
    >
        <div class="c-tr">
            <location-badge
                class="c-td is-1"
                :logo="$options.LOGOS.EP"
                :location="row.epLoc"
            />

            <location-badge
                class="c-td is-2"
                :logo="$options.LOGOS.KPL"
                :location="kplLocData"
            />

            <div class="c-td is-3">
                <a-icon
                    v-if="status"
                    v-tooltip="status.tooltip"
                    width="1.5rem"
                    height="1.5rem"
                    :icon="status.icon"
                    :class="status.class"
                />
            </div>
        </div>
    </div>
</template>

<script>
import locationMappingMixin, { VALID_DATA_STATUS } from '@/components/drs/service/location-mapping.mixin'
import { LOGOS } from '@/utils/constants/drs/logos'

export default {
    mixins: [locationMappingMixin],

    LOGOS,
    VALID_DATA_STATUS,

    props: {
        row: {
            type: Object,
            required: true
        }
    },

    computed: {
        kplLocData() {
            if (!this.row.kplLoc) {
                return {
                    name: 'Brak (nie ma wskazanego sklepu w Kaucyjni.pl)'
                }
            }

            return this.row.kplLoc
        },

        status() {
            switch (this.row.status) {
            case VALID_DATA_STATUS.OK:
                return {
                    icon: 'Ok',
                    tooltip: 'Pełna zgodność między sklepami'
                }

            case VALID_DATA_STATUS.INVALID:
                return {
                    icon: 'WarningFull',
                    tooltip: 'Brak zgodności między sklepami',
                    class: 'text-danger'
                }

            case VALID_DATA_STATUS.NONE:
                return {
                    icon: 'Ban',
                    tooltip: 'Brak sklepu w Kaucyjni.pl',
                    class: 'text-muted'
                }

            default:
                return null
            }
        }

    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
@import './location-mapping-table';

.location-mapping-summary-table {
    @extend .location-mapping-table-base;

    .c-td {
        --width: 40%;
    }

    .is-3 {
        --width: 6rem;
        max-width: var(--width);
        display: flex;
        justify-content: center;
    }
}
</style>
